<template>
  <Card :title="title">
    <div class="flex flex-col items-center justify-center h-full">
      <p class="text-center text-gray-500 text-lg">[Insert Graph AI Here]</p>
    </div>
  </Card>
</template>

<script>
import Card from '../Card.vue'

export default {
  name: 'ComparisonCostDeployment',
  components: {
    Card
  },
  props: {
    title: {
      type: String,
      default: 'Cost vs Deployments'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/CostAgainstDeploymentsCard.vue